module.exports = __webpack_public_path__ + "img/PAY.3f0b0c89.svg";